import { faGlobe, faGem, faLock, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

/**
 * 貼文內容瀏覽權限（對應後端 post_visibility_type）。
 *
 * 全站唯一來源：設定表單的選項卡片、建立/編輯的設定標籤、貼文卡片右上角標籤都取自這裡，
 * 分類名稱與 icon 一致，隱藏付費解鎖是獨立一類（不拆成「隱藏」+「付費」兩個標籤）。
 */
export const VISIBILITY_OPTIONS = [
  { value: 0, icon: faGlobe, titleKey: 'post_visibility_public', descKey: 'post_visibility_public_desc' },
  { value: 1, icon: faGem, titleKey: 'post_visibility_subscribers', descKey: 'post_visibility_subscribers_desc' },
  { value: 2, icon: faLock, titleKey: 'post_visibility_paid', descKey: 'post_visibility_paid_desc', needsPrice: true },
  { value: 3, icon: faEyeSlash, titleKey: 'post_visibility_hidden', descKey: 'post_visibility_hidden_desc' },
  { value: 4, icon: faLock, titleKey: 'post_visibility_hidden_paid', descKey: 'post_visibility_hidden_paid_desc', needsPrice: true },
];

// 後端若回傳未定義的權限值，取不到選項（呼叫端不顯示標籤），不另外編造預設分類
export const getVisibilityOption = (value) =>
  VISIBILITY_OPTIONS.find(option => option.value === Number(value));
